import * as React from "react";
import type { SVGProps } from "react";
const SvgCutoverIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="cutover_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M496.896 700.501a38.613 38.613 0 0 0-57.813 0l-79.147 85.931V385.365a42.667 42.667 0 0 0-85.333 0v398.55l-76.8-83.414a38.613 38.613 0 0 0-57.814 0 47.147 47.147 0 0 0 0 62.763l149.547 162.39a38.613 38.613 0 0 0 57.813 0l149.547-162.39a47.147 47.147 0 0 0 0-62.763zm387.285-376.746a38.23 38.23 0 0 1-57.514 0l-77.782-85.163v399.701a42.667 42.667 0 0 1-85.333 0V241.067l-75.435 82.645a38.23 38.23 0 0 1-57.557 0 47.616 47.616 0 0 1 0-63.019L678.613 98.56a38.23 38.23 0 0 1 57.558 0l148.053 162.133c15.872 17.408 15.872 45.654 0 63.019z"
    />
  </svg>
);
export default SvgCutoverIcon;
